// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"e792e506","995":"21ccb8b0"}[chunkId] + ".chunk.js";
};